import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import PropTypes from 'prop-types';
import CountUp from 'react-countup';
import { Col } from 'react-bootstrap';

const HeaderCard = ({ data, title, icon = 'check', color = 'primary' }) => {
  return (
    <>
      <Col
        className={`border-md-end border-bottom border-xxl-bottom-0 pb-3 p-xxl-0 ps-md-0 px-3 px-3 text-center`}
      >
        <div className={`icon-circle icon-circle-${color}`}>
          <FontAwesomeIcon icon={icon} className={`fs-7 text-${color}`} />
        </div>
        <h4 className="mb-1 font-sans-serif">
          <CountUp
            start={0}
            end={data}
            duration={2.75}
            className="text-700"
            separator=","
          />
        </h4>

        <p className="fs-10 fw-semibold mb-0 text-700">{title}</p>
      </Col>
    </>
  );
};
HeaderCard.propTypes = {
  data: PropTypes.array.isRequired,
  width: PropTypes.string,
  amountClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  subData: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string
};

export default HeaderCard;
